import { BONUS_STATUS, BONUS_TYPES } from './constants'

/**
 * Checks if the bonus is eligible for calling availBonus.
 * @param {Object} item - Bonus item object.
 * @returns {boolean}
 */
export function isCallAvailBonus (item) {
  return (
    item.status !== BONUS_STATUS.CANCELLED &&
    item.status !== BONUS_STATUS.FORFEIT &&
    item.status !== BONUS_STATUS.EXPIRED &&
    item.status !== BONUS_STATUS.COMPLETED &&
    item.status !== BONUS_STATUS.ZEROED_OUT &&
    item.status !== BONUS_STATUS.LAPSED
  )
}

/**
 * Sports freebet bonuses do not require a deposit after activation.
 * @param {Object|string} bonus - Bonus item object or bonus type string.
 * @returns {boolean}
 */
export function isSportsFreebetBonus (bonus) {
  const bonusType = typeof bonus === 'string' ? bonus : bonus?.bonusType
  return bonusType === BONUS_TYPES.SPORTS_FREEBET
}
